import styles from './ColorRectangle.module.scss'
export const ColorRectangle = ({ children, blue, ...props }) => {
	return <div className={`${styles.wrapper} ${blue ? styles.wrapper__blue : styles.wrapper__green}`}>{children}</div>
}
